import { SET_ROUTE, UPDATE_HASH_PARAMS } from './constants';
import { history } from './history';
export const actionSetRoute = (location, route, params) => {
    const hashParams = {};
    if (location.hash) {
        const hashSearchParams = new URLSearchParams(location.hash.slice(1));
        for (const [key, value] of hashSearchParams.entries()) {
            hashParams[key] = value;
        }
    }
    return {
        type: SET_ROUTE,
        // make shallow copy
        payload: {
            ...location,
            hashParams,
            params,
            route,
        },
    };
};
export const actionUpdateHashParams = (newHashParams) => {
    const urlHash = window.location.hash;
    const hashParams = new URLSearchParams(urlHash.slice(1));
    for (const [key, value] of Object.entries(newHashParams)) {
        value === undefined ? hashParams.delete(key) : hashParams.set(key, value);
    }
    const url = new URL(window.location.href);
    url.hash = hashParams.toString();
    history.replaceWithoutDispatch(url.toString());
    return {
        type: UPDATE_HASH_PARAMS,
        // make shallow copy
        payload: {
            hashParams: newHashParams,
            hash: url.hash,
        },
    };
};
//# sourceMappingURL=actions.js.map